{
	"approveContract": "Aprobar contrato",
	"description": "Tienes contratos pendientes de acuerdo.",
	"deselectAllContracts": "Desmarcar todos los contratos",
	"modalApproveConfirmation": {
		"description": "Para finalizar la firma y confirmar la aprobación, enviaremos un código al correo electrónico registrado. Al finalizar la firma, solo podrás cancelar contactando al canal de soporte.",
		"header": "Confirmación de aprobación",
		"reminder": "Recordatorio: verifica tu carpeta de spam, el correo con el código puede haber sido dirigido allí.",
		"sendCode": "Enviar código"
	},
	"modalCodeConfirmation": {
		"codePlaceholder": "Ingresa el código enviado",
		"confirmSign": "Confirmar firma",
		"description": "Ingresa el código de confirmación para completar la firma de la solicitud.",
		"verifyCode": "Código de confirmación"
	},
	"request": "Solicitud #{{request}}",
	"selectAllContracts": "Seleccionar todos los contratos",
	"title": "Términos y contratos pendientes"
}
